import styled from 'styled-components';
import grey from 'sushiweb/tokens/color/grey';

export const OrderExpenseRequestCenterAlign = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 60rem;
  gap: 1.5rem;
  h2 {
    font-size: 3rem;
    font-weight: 800;
    font-style: normal;
    color: ${grey.z900};
    text-align: center;
    text-decoration: none;
  }
  h4 {
    font-size: 2rem;
    color: ${grey.z500};
    margin-bottom: 1rem;
    text-align: center;
    text-decoration: none;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  p {
    font-size: 1.6rem;
    color: ${grey.z900};
  }
  margin: 1.5rem 0;
`;
